module.exports = __webpack_public_path__ + "static/media/logo_short.37b588ee.svg";